import { render, staticRenderFns } from "./scope8.vue?vue&type=template&id=244d0a20&scoped=true"
import script from "./scope8.vue?vue&type=script&lang=js"
export * from "./scope8.vue?vue&type=script&lang=js"
import style0 from "./scope8.vue?vue&type=style&index=0&id=244d0a20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d0a20",
  null
  
)

export default component.exports